import * as React from 'react'

import ItemCard from '../../itemCard'
import ItemCardsLayout from '../../itemCardsLayout'
import { IItemsListing } from '../index'

const Default = ({ items, viewType, showSingleRow }: IItemsListing) => (
  <ItemCardsLayout viewType={viewType} showSingleRow={showSingleRow}>
    {items.map((item, index) => (
      <ItemCardsLayout.CardArea key={item.id}>
        <ItemCard item={item} index={index} viewType={viewType} />
      </ItemCardsLayout.CardArea>
    ))}
  </ItemCardsLayout>
)
export default Default
